module.exports = __webpack_public_path__ + "static/media/twitter.4dd8c4e2.png";